skyward.base.registerScript("calculatedFieldList", function (skyward, $)
{
    skyward.calculatedFieldList = skyward.calculatedFieldList || {};

    var init = function ()
    {
        const calculatedFieldList = $(this);

        const relatedTreeBrowseName = calculatedFieldList.data("relatedTreeBrowse");
        const relatedTreeBrowse = skyward.treebrowse.getTreeBrowseContainer(relatedTreeBrowseName);

        calculatedFieldList.find(".add_calculated_field").on("click", function () { addCalculatedField($(this)); });
        calculatedFieldList.find(".delete_calculated_field").on("click", function () { removeCalculatedField($(this), relatedTreeBrowse); });
        calculatedFieldList.find(".edit_calculated_field").on("click", function () { editCalculatedField($(this), relatedTreeBrowse); });
        relatedTreeBrowse.on("treeBrowseRowChange", function (_treeBrowseData, rowData) { calculatedFieldClicked(rowData, calculatedFieldList); });
    };

    var toggleEditAndDelete = function (calculatedFieldList, enabled)
    {
        calculatedFieldList.find(".delete_calculated_field, .edit_calculated_field").toggleClass("ui-disabled", !enabled);
    };

    var calculatedFieldClicked = function (rowData, calculatedFieldList)
    {
        toggleEditAndDelete(calculatedFieldList, rowData.isCalculatedField);
    };

    var addCalculatedField = function (button)
    {
        const listData = button.closest(".calculatedFieldList").data();

        skyward.calculatedFieldBuilder.launch({
            callback: skyward.reporting.addCalculatedField,
            schemaObject: listData.schemaObject,
            relationshipPath: listData.relationshipPath,
            prompts: skyward.reporting.prompts.promptCollection,
            usedInExistsFilter: false
        });
    };

    var removeCalculatedField = function (button, relatedTreeBrowse)
    {
        if (button.hasClass("ui-disabled"))
        {
            return;
        }

        const selectedItem = skyward.treebrowse.getSelectedFieldData(relatedTreeBrowse);
        if (!selectedItem.isCalculatedField)
        {
            return;
        }

        skyward.reporting.removeCalculatedField(selectedItem.id);
        const calculatedFieldList = button.closest(".calculatedFieldList");
        toggleEditAndDelete(calculatedFieldList, false);
    };

    var editCalculatedField = function (button, relatedTreeBrowse)
    {
        if (button.hasClass("ui-disabled"))
        {
            return;
        }

        const selectedItem = skyward.treebrowse.getSelectedFieldData(relatedTreeBrowse);
        if (!selectedItem || !selectedItem.isCalculatedField)
        {
            return;
        }

        skyward.reporting.updateCalculatedField(selectedItem.id);
    };

    /**
     * @param {object} treeBrowseData The tree browse that hosts the calculated field list
     * @param {CalculatedFieldProps[]} calculatedFields The calculated fields that may be shown.  They will be filtered by module/object/relationshipPath.
     * @param {string | undefined} container Selector for the target element where the calculated field list will be added.  This is
     * required for editable calculated field lists, but can be unset otherwise.
     * @param {any} module The root schema module to filter on and to assign to new calculated fields.
     * @param {any} object The root schema object to filter on and to assign to new calculated fields.
     * @param {any} relationshipPath The relationship path to filter on and to assign to new calculated fields.
     * @param {string | undefined} rootExistsPath The exist relationship path if in an exists
     */
    skyward.calculatedFieldList.updateCalculatedFieldList = function (treeBrowseData, calculatedFields, container, module, object, relationshipPath, rootExistsPath)
    {
        const schemaObject = module + "." + object;
        const relationship = relationshipPath || "";

        const list = $(container).closest(".calculatedFieldList");
        const listData = list.data();
        if (listData !== undefined)
        {
            listData.schemaObject = schemaObject;
            listData.relationshipPath = relationship;
        }

        const filteredFields = filterCalculatedFields(calculatedFields, schemaObject, relationship, rootExistsPath);

        let calculatedFieldTreeBrowseSection = treeBrowseData.additionalSections.find(function (section) { return section.key === "calculatedFields"; });
        if (!calculatedFieldTreeBrowseSection)
        {
            calculatedFieldTreeBrowseSection =
            {
                key: "calculatedFields",
                component: "calculatedField",
                container: container,
                title: container ? undefined : "Calculated Fields",
                rows: []
            };
            treeBrowseData.additionalSections.push(calculatedFieldTreeBrowseSection);
        }
        calculatedFieldTreeBrowseSection.rows = filteredFields;

        if (!treeBrowseData.getSelectedFieldData())
        {
            toggleEditAndDelete(list, false);
        }
    };

    skyward.calculatedFieldList.filterCalculatedFieldList = function (calculatedFields, module, object, relationshipPath, rootExistsPath)
    {
        const schemaObject = module + "." + object;
        const relationship = relationshipPath || "";

        return filterCalculatedFields(calculatedFields, schemaObject, relationship, rootExistsPath);
    };

    function filterCalculatedFields(calculatedFields, schemaObject, relationship, rootExistsPath)
    {
        const filteredFields = calculatedFields.filter(function (field)
        {
            if (rootExistsPath && field.usesParentField)
            {
                return false;
            }

            const fieldRelationshipPath = field.relationshipPath || "";
            return (field.schemaObject === schemaObject && fieldRelationshipPath == relationship) || (fieldRelationshipPath == rootExistsPath);
        });

        filteredFields.sort(function (a, b)
        {
            return a.fieldName.toUpperCase().localeCompare(b.fieldName.toUpperCase());
        });

        return filteredFields;
    }

    return { init: init };
});